import { render, staticRenderFns } from "./GeoLoc.vue?vue&type=template&id=bc2da63c"
import script from "./GeoLoc.vue?vue&type=script&lang=js"
export * from "./GeoLoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports